import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './LimitReachedPage.css';

const LimitReachedPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isStorageLimit = location.search.includes('type=storage');

  return (
    <div className="limit-page">
      <div className="limit-container">
        <h1 className="limit-title">
          {isStorageLimit
            ? 'Speicherplatzlimit erreicht'
            : 'Immobilienlimit erreicht'}
        </h1>
        <p className="limit-description">
          Dein aktueller Plan erlaubt keine{' '}
          {isStorageLimit ? 'weiteren Uploads' : 'weiteren Immobilien'}. Bitte
          upgrade dein Abonnement, um fortzufahren.
        </p>
        <div className="limit-actions">
          <button
            className="limit-button upgrade-button"
            onClick={() => navigate('/shop')}
          >
            Abonnements ansehen
          </button>
          <button
            className="limit-button back-button"
            onClick={() => navigate(-1)}
          >
            Zurück
          </button>
        </div>
      </div>
    </div>
  );
};

export default LimitReachedPage;
